// файл OnlinePay.js

import React, { useState } from 'react';

const OnlinePay = () => {
  // Состояние для хранения данных формы
  const [cardNumber, setCardNumber] = useState('');
  const [cardHolder, setCardHolder] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [cvv, setCvv] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Обработчик изменения полей ввода
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setIsSubmitted(false); // Сброс состояния отправки
  };

  // Проверка заполненности всех полей
  const isFormIncomplete = () => {
    return !cardNumber || !cardHolder || !expiryDate || !cvv;
  };

  // Обработчик отправки формы
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true); // Отмечаем, что форма была отправлена

    if (!isFormIncomplete()) {
      alert('Payment processed successfully!'); // Здесь можно заменить на логику обработки платежа
      // Очистить поля после успешной отправки
      setCardNumber('');
      setCardHolder('');
      setExpiryDate('');
      setCvv('');
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        margin: "0",
        padding: "0",
        backgroundColor: "#121212", // Тёмный фон для страницы
        color: "#ffffff", // Белый цвет текста
        minHeight: "100vh", // Минимальная высота страницы
        display: "flex", // Центрируем форму по вертикали
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Заголовок страницы */}
      <h1>Online Payment</h1>

      {/* Форма ввода данных платежной карты */}
      <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
        <div style={{ marginBottom: "15px" }}>
          <input
            type="text"
            id="cardNumber"
            value={cardNumber}
            onChange={handleInputChange(setCardNumber)} // Обработчик изменения
            placeholder="Card Number"
            maxLength="16"
            style={{
              padding: "10px",
              width: "300px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <input
            type="text"
            id="cardHolder"
            value={cardHolder}
            onChange={handleInputChange(setCardHolder)} // Обработчик изменения
            placeholder="Card Holder Name"
            style={{
              padding: "10px",
              width: "300px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
          <input
            type="text"
            id="expiryDate"
            value={expiryDate}
            onChange={handleInputChange(setExpiryDate)} // Обработчик изменения
            placeholder="MM/YY"
            maxLength="5"
            style={{
              padding: "10px",
              width: "120px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />

          <input
            type="text"
            id="cvv"
            value={cvv}
            onChange={handleInputChange(setCvv)} // Обработчик изменения
            placeholder="CVV"
            maxLength="3"
            style={{
              padding: "10px",
              width: "120px",
              borderRadius: "5px",
              border: "1px solid #333", // Тёмная граница
              backgroundColor: "#333", // Тёмный фон для поля ввода
              color: "#fff", // Белый текст в поле
              fontSize: "16px", // Размер шрифта
            }}
          />
        </div>

        <button
          type="submit"
          disabled={isFormIncomplete()} // Кнопка неактивна, если поля пустые
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            backgroundColor: isFormIncomplete() ? "#aaaaaa" : "#6200ea", // Цвет кнопки в зависимости от состояния
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: isFormIncomplete() ? "not-allowed" : "pointer", // Изменение курсора в зависимости от состояния
            marginTop: "10px",
            opacity: isFormIncomplete() ? 0.6 : 1, // Уменьшаем яркость кнопки, если она неактивна
          }}
        >
          Pay Now
        </button>
      </form>

      {/* Сообщение об успешной отправке */}
      {isSubmitted && !isFormIncomplete() && (
        <div style={{ color: "green", marginTop: "20px" }}>
          Payment successfully processed!
        </div>
      )}
    </div>
  );
};

export default OnlinePay;
